<button
  (click)="hightLight.emit(lowestPrice)"
  appButton="small"
  class="small-button--margin"
  [id]="id"
>
  {{ message }}{{ lowestPrice | currency: 'GBP' }}
</button>
